/**
 * 同名王国详情 UI 复原样例。
 * 来源：2026-10-16「文化传媒（KPL）」参考图。
 * 不是接口返回，不写入数据库。
 */
export const CULTURE_KINGDOM_REFERENCE = {
  id: 'culture-kpl-20261016',
  tradeDate: '2026-10-16',
  name: '文化传媒（KPL）',
  kind: '同名王国',
  kingName: '新华传媒',
  kingCode: '600825',
  metrics: [
    { label: '王国总览', value: '+185.5%', hint: '龙头以来涨幅', tone: 'up' },
    { label: '当前最高板', value: '11板', hint: '', tone: 'blue' },
    { label: '补涨最高高度', value: '5B', hint: '', tone: 'blue' },
    { label: '独立涨停数', value: '18', hint: '', tone: 'blue' },
    { label: '平均红盘率', value: '72.6%', hint: '', tone: 'up' }
  ],
  roles: [
    {
      key: 'king',
      tag: '国王',
      tone: 'gold',
      name: '新华传媒',
      code: '600825',
      price: '15.16',
      change: '+0.00%',
      badge: '14天11板',
      desc: '文化传媒（KPL）王国当前国王，市场最高标杆',
      stats: [
        { value: '+185.5%', label: '龙头以来涨幅', tone: 'up' },
        { value: '11板', label: '当前最高板', tone: 'text' },
        { value: '8.2亿', label: '今日成交额', tone: 'text' },
        { value: '72.6%', label: '近5日红盘率', tone: 'up' }
      ]
    },
    {
      key: 'trend',
      tag: '趋势龙',
      tone: 'blue',
      name: '新华文轩',
      code: '601811',
      price: '28.14',
      change: '+10.01%',
      badge: '15天11板',
      desc: '王国内趋势最强，持续放量走强',
      stats: [
        { value: '+122.6%', label: '近15日涨幅', tone: 'up' },
        { value: '11板', label: '最高板', tone: 'text' },
        { value: '6.7亿', label: '今日成交额', tone: 'text' },
        { value: '68.4%', label: '近5日红盘率', tone: 'up' }
      ]
    },
    {
      key: 'board',
      tag: '连板龙',
      tone: 'rose',
      name: '新经典',
      code: '603096',
      price: '10.74',
      change: '+10.02%',
      badge: '4天4板',
      desc: '王国内连板高度代表，打出高度空间',
      stats: [
        { value: '+36.1%', label: '近15日涨幅', tone: 'up' },
        { value: '4板', label: '最高板', tone: 'text' },
        { value: '4.1亿', label: '今日成交额', tone: 'text' },
        { value: '60.0%', label: '近5日红盘率', tone: 'up' }
      ]
    }
  ],
  ladderTitle: '当前连板池',
  ladderSub: '按当前连板高度划分，展示王国内核心梯队个股',
  ladders: [
    {
      key: 'top',
      title: '首板池',
      tone: 'rose',
      count: 1,
      rows: [
        ['新经典', '603096', '4板', '+36.1%', '+10.02%', '+9.99%']
      ]
    },
    {
      key: 'ge4',
      title: '≥4B池',
      tone: 'blue',
      count: 3,
      rows: [
        ['新华传媒', '600825', '11板', '+185.5%', '+0.00%', '+10.01%'],
        ['新华文轩', '601811', '11板', '+122.6%', '+10.01%', '+10.01%'],
        ['内蒙新华', '603230', '4板', '+36.1%', '+9.98%', '+9.99%']
      ]
    },
    {
      key: 'b3',
      title: '3B池',
      tone: 'orange',
      count: 4,
      rows: [
        ['凤凰传媒', '601928', '3板', '+12.3%', '+9.99%', '+9.99%'],
        ['中国科传', '601858', '3板', '+8.21%', '+9.96%', '+9.96%'],
        ['读者传媒', '603999', '3板', '+27.9%', '+9.51%', '+9.51%'],
        ['上海电影', '601595', '3板', '+18.4%', '+9.23%', '+8.65%']
      ]
    },
    {
      key: 'b2',
      title: '2B池',
      tone: 'green',
      count: 5,
      rows: [
        ['奥飞娱乐', '002292', '2板', '+27.5%', '+9.97%', '-3.86%'],
        ['华策影视', '300133', '2板', '+18.9%', '+4.76%', '+0.99%'],
        ['慈文传媒', '002343', '2板', '+12.8%', '+3.32%', '-0.37%'],
        ['光线传媒', '300251', '2板', '+13.3%', '+8.26%', '+1.23%'],
        ['万达电影', '002739', '2板', '+9.6%', '+6.15%', '-2.41%']
      ]
    }
  ],
  nonLeaderHeight: '5B',
  mainAttrs: ['文化传媒', '电竞', '短剧/游戏', 'AI应用'],
  heightRows: [
    { name: '新华文轩', height: '5B', finalBoard: '15天11板', total: '+102.45%', ff: '43.1亿', prem: '+10.01%', concepts: ['文化传媒', '电竞'] },
    { name: '内蒙新华', height: '5B', finalBoard: '7天6板', total: '+1.78%', ff: '14.52亿', prem: '+10.04%', concepts: ['文化传媒', '在线教育'] },
    { name: '新经典', height: '4B', finalBoard: '4天4板', total: '+36.1%', ff: '10.74亿', prem: '+10.02%', concepts: ['文化传媒', '短剧游戏'] },
    { name: '龙版传媒', height: '3B', finalBoard: '5天4板', total: '+5.03%', ff: '14.8亿', prem: '+9.99%', concepts: ['文化传媒', '出版'] },
    { name: '读者传媒', height: '2B', finalBoard: '2天2板', total: '+27.84%', ff: '18.51亿', prem: '—', concepts: ['文化传媒', '体育赛事'] }
  ],
  relayRows: [
    { name: '奥飞娱乐', mid: '78', heat: '55', ff: '32.1亿', tier: '2B', concept: '文化传媒' },
    { name: '华策影视', mid: '75', heat: '52', ff: '18.6亿', tier: '2B', concept: '文化传媒' },
    { name: '慈文传媒', mid: '72', heat: '48', ff: '15.6亿', tier: '2B', concept: '文化传媒' },
    { name: '光线传媒', mid: '68', heat: '45', ff: '102.4亿', tier: '1B', concept: '文化传媒' },
    { name: '万达电影', mid: '64', heat: '40', ff: '16.3亿', tier: '1B', concept: '文化传媒' }
  ],
  catchupCols: [
    {
      key: 'ge4',
      title: '曾≥4B池',
      tone: 'rose',
      count: 3,
      total: '—',
      red: '—',
      rows: [
        ['新华文轩', '601811', '5板', '+102.45%', '92%', '+10.01%'],
        ['内蒙新华', '603230', '5板', '+1.78%', '67%', '+10.04%'],
        ['新经典', '603096', '4板', '+36.1%', '83%', '+10.02%']
      ]
    },
    {
      key: 'b3',
      title: '3B池',
      tone: 'orange',
      count: 4,
      total: '—',
      red: '—',
      rows: [
        ['凤凰传媒', '601928', '3板', '+12.30%', '50%', '+9.99%'],
        ['读者传媒', '603999', '3板', '+27.9%', '67%', '+9.51%'],
        ['中国科传', '601858', '3板', '+8.21%', '67%', '+9.96%'],
        ['上海电影', '601595', '3板', '+18.4%', '50%', '+8.65%']
      ]
    },
    {
      key: 'b2',
      title: '2B池',
      tone: 'green',
      count: 5,
      total: '—',
      red: '—',
      rows: [
        ['奥飞娱乐', '002292', '2板', '+27.94%', '67%', '-3.86%'],
        ['华策影视', '300133', '2板', '+18.94%', '33%', '+0.99%'],
        ['慈文传媒', '002343', '2板', '+12.81%', '67%', '-0.37%'],
        ['光线传媒', '300251', '2板', '+11.35%', '33%', '+1.23%'],
        ['万达电影', '002739', '2板', '+9.60%', '33%', '-2.41%']
      ]
    }
  ],
  conceptChips: [
    ['文化传媒', 28],
    ['电竞', 12],
    ['短剧游戏', 11],
    ['在线教育', 8],
    ['出版', 7],
    ['影视院线', 6],
    ['IP经济', 6],
    ['虚拟现实', 5],
    ['AI应用', 4],
    ['数字阅读', 4],
    ['动漫', 3]
  ],
  themeRows: [
    {
      name: '文化传媒（KPL）',
      since: '+185.5%',
      d5: '+46.2%',
      d10: '+122.8%',
      cum: 37,
      indep: 18,
      avgRed: '72.6%',
      todayRed: '66.7%',
      todayLimit: '—',
      ge4: 3,
      b3: 4,
      b2: 5,
      heat: 5
    }
  ]
}
